import { createI18n } from 'vue-i18n'

import { FINNISH_TRANSLATIONS } from './fi';
import { SWEDISH_TRANSLATIONS } from './sv';
import { ENGLISH_TRANSLATIONS } from './en';

const TRANSLATIONS = {
    fi: FINNISH_TRANSLATIONS,
    sv: SWEDISH_TRANSLATIONS,
    en: ENGLISH_TRANSLATIONS
};

// Set default language
let locale = "fi"

if ( document.documentElement.lang === 'sv-SE') {
    locale = "sv"
}
if ( document.documentElement.lang === 'en-US') {
    locale = "en"
}

export default createI18n({
    locale: locale,
    messages: TRANSLATIONS,
    legacy: false
});